import cloneDeep from 'lodash/cloneDeep';
import {pluck} from "~/helpers/common";

export function setSteps(state, steps) {
  steps = steps.map((step, index) => {
    step.order = index;

    return step;
  })
  state.steps = steps;
}

export function initSteps(state, steps) {
  steps.sort((a, b) => a.order - b.order);
  steps.forEach(step => {
    step.related_templates = step.related_proposals;
    step.tasks.forEach(task => {
      task.related_templates = task.related_proposals;
    })
  })

  state.steps = steps;
}

export function resetStep(state) {
  state.steps = [];
}

export function addStep(state, step) {
  step.order = state.steps.length;
  state.steps.push(step);
}

export function updateStep(state, {stepIndex, dataUpdate}) {
  const {title, content, start, end, options, users_assign, related_templates, related_papers,
    day_start_after_settlement_month,
    day_end_after_settlement_month,
    month_start_after_settlement_month,
    month_end_after_settlement_month,
  } = dataUpdate;
  if (title !== undefined) {
    state.steps[stepIndex].title = title;
  }
  if (content !== undefined) {
    state.steps[stepIndex].content = content;
  }
  if (start !== undefined) {
    state.steps[stepIndex].start = start;
  }
  if (end !== undefined) {
    state.steps[stepIndex].end = end;
  }
  if (options !== undefined) {
    state.steps[stepIndex].options = options;
  }
  if (users_assign !== undefined) {
    state.steps[stepIndex].users_assign = users_assign;
  }
  if (related_templates !== undefined) {
    state.steps[stepIndex].related_templates = related_templates;
  }
  if (related_papers !== undefined) {
    state.steps[stepIndex].related_papers = related_papers;
  }
  if (day_start_after_settlement_month !== undefined) {
    state.steps[stepIndex].day_start_after_settlement_month = day_start_after_settlement_month;
  }
  if (day_end_after_settlement_month !== undefined) {
    state.steps[stepIndex].day_end_after_settlement_month = day_end_after_settlement_month;
  }
  if (month_start_after_settlement_month !== undefined) {
    state.steps[stepIndex].month_start_after_settlement_month = month_start_after_settlement_month;
  }
  if (month_end_after_settlement_month !== undefined) {
    state.steps[stepIndex].month_end_after_settlement_month = month_end_after_settlement_month;
  }
}

export function swapTask(state, {oldIndex, newIndex, stepIndex}) {
  let tasks = cloneDeep(state.steps[stepIndex].tasks);
  [tasks[oldIndex], tasks[newIndex]] = [tasks[newIndex], tasks[oldIndex]]
  tasks = tasks.map((task, index) => {
    task.order = index

    return task;
  });

  state.steps[stepIndex].tasks = tasks;
}

export function deleteStep(state, index) {
  state.steps.splice(index, 1);
}

export function addTask(state, {stepIndex, task}) {
  task.order = state.steps[stepIndex].tasks.length;
  state.steps[stepIndex].tasks.push(task);
}

export function updateTask(state, {stepIndex, taskIndex, dataUpdate}) {
  if (dataUpdate.content !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].content = dataUpdate.content;
  }

  if (dataUpdate.start !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].start = dataUpdate.start;
  }

  if (dataUpdate.end !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].end = dataUpdate.end;
  }

  if (dataUpdate.options !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].options = dataUpdate.options;
  }

  if (dataUpdate.users_assign !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].users_assign = dataUpdate?.users_assign || null;
  }

  if (dataUpdate?.related_templates !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].related_templates = dataUpdate?.related_templates || [];
  }

  if (dataUpdate?.related_papers !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].related_papers = dataUpdate?.related_papers || [];
  }

  if (dataUpdate.day_start_after_settlement_month !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].day_start_after_settlement_month = dataUpdate.day_start_after_settlement_month;
  }

  if (dataUpdate.day_end_after_settlement_month !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].day_end_after_settlement_month = dataUpdate.day_end_after_settlement_month;
  }

  if (dataUpdate.month_start_after_settlement_month !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].month_start_after_settlement_month = dataUpdate.month_start_after_settlement_month;
  }

  if (dataUpdate.month_end_after_settlement_month !== undefined) {
    state.steps[stepIndex].tasks[taskIndex].month_end_after_settlement_month = dataUpdate.month_end_after_settlement_month;
  }
}

export const setStepStatus = (state, {stepIndex, status}) => {
  state.steps[stepIndex].status = status;
};

export const updateAllTaskStatus = (state, {stepIndex, status}) => {
  state.steps[stepIndex].tasks.map((task, index) => {
    task.status = status;
  })
};

export const setTaskStatus = (state, {stepIndex, taskIndex, status}) => {
  state.steps[stepIndex].tasks[taskIndex].status = status;
};

export function deleteTask(state, {stepIndex, taskIndex}) {
  state.steps[stepIndex].tasks.splice(taskIndex, 1);
}

export function addStepToTrash(state, id) {
  if (id && !!state.trash.steps.indexOf(id)) {
    state.trash.steps.push(id);
  }
}

export function addTaskToTrash(state, id) {
  if (id && !!state.trash.tasks.indexOf(id)) {
    state.trash.tasks.push(id);
  }
}

export function emptyTrash(state) {
  state.trash = {
    steps: [],
    tasks: []
  };
}
